import { OperatorFunction, ignoreElements, pipe } from 'rxjs';

export function ignoreElementsTyped<T>(): OperatorFunction<T, never> {
    return pipe(ignoreElements());
}
